import React from 'react'
import PropTypes from 'prop-types'
import ChatMessageView from '../component/ChatMessageView'
import { CHAT_MESSAGE_TYPES } from '../../../../shared/constants'
import ChatImagePreview from '../contents/ChatImagePreview/ChatImagePreview'
import ChatMediaPreview from '../contents/ChatMediaPreview/ChatMediaPreview'
import ChatText from '../contents/ChatText/ChatText'

const getMessageContent = ({ type, text, fileURL }) => {
  if (type === CHAT_MESSAGE_TYPES.IMAGE) {
    return <ChatImagePreview fileURL={fileURL} />
  }
  if ([CHAT_MESSAGE_TYPES.VIDEO, CHAT_MESSAGE_TYPES.FILE].includes(type)) {
    return <ChatMediaPreview type={type} fileURL={fileURL} />
  }
  return <ChatText text={text || fileURL} />
}

const ChatMessage = ({
  isOwnMessage,
  text,
  author,
  time,
  status,
  type,
  fileURL,
  profilePicture,
}) => {
  const content = getMessageContent({ type, text, fileURL })

  return (
    <ChatMessageView
      isOwnMessage={isOwnMessage}
      text={text}
      author={author}
      time={time}
      status={status}
      profilePicture={profilePicture}
    >
      {content}
    </ChatMessageView>
  )
}

ChatMessage.propTypes = {
  isOwnMessage: PropTypes.bool,
  text: PropTypes.string,
  author: PropTypes.string,
  time: PropTypes.string,
  status: PropTypes.string,
}

export default ChatMessage



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessage/container/ChatMessage.js